module.exports = __webpack_public_path__ + "img/status@3x.4e7ccdfe.png";